import { Component, OnInit, inject } from '@angular/core';

import { RouterLink } from '@angular/router';
import { PageTitleService } from '../../core/services/page-title.service';
import { CounselService } from '../../core/services/counsel.service';

@Component({
    selector: 'app-program',
    imports: [RouterLink],
    templateUrl: './program.component.html'
})
export class ProgramComponent implements OnInit {
  private pageTitle = inject(PageTitleService);
  private counselService = inject(CounselService);

  levels: { level: number; icon: string }[] = [];

  async ngOnInit(): Promise<void> {
    this.pageTitle.set('fa s-icon-clinical_notes', 'プログラム');
    const data = await this.counselService.getTrainingProgramList();
    if (Array.isArray(data) && data.length > 0) {
      this.levels = data.reduce((acc: any[], x: any) => {
        if (x.level !== 999 && !acc.find(({ level }) => level === x.level)) acc.push({ level: x.level, icon: x.icon });
        return acc;
      }, []);
    }
  }
}
